import { Locale, baseLocaleMessage } from '../utils/i18n.js';
import EN from './en-US/index.js';
import JP from './ja-JP/index.js';
import KO from './ko-KR/index.js';
import PT from './pt-PT/index.js';
import CN from './zh-CN/index.js';
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var LocaleStore = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Locale.CN, CN), Locale.EN, EN), Locale.JP, JP), Locale.PT, PT), Locale.KO_KR, KO);
var localeMessage = function localeMessage(props, values) {
  return baseLocaleMessage(LocaleStore)(props, values);
};
export { localeMessage };
